// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nq-1";
export var stateContainer = "_nq-0";